import PropTypes from 'prop-types';

import {
  StyledPairedButtonWrapper,
  StyledPairedButton,
} from './StyledPairedButton';
import { StyledMoreButton } from './StyledMoreButton';

// PairedButtons can be provided with activeButton prop, which means whether should PairedButtons call provided fn on firstload or not.
// active prop means what button should be active on firstload (index);

export const PairedButtons = ({
  text = [''],
  fn = () => null,
  active = 0,
  disabled = false,
  small = false,
}) => {
  const toggleActive = index => e => {
    e.stopPropagation();
    fn(index);
  };

  return (
    <StyledPairedButtonWrapper>
      {text.map((buttonText, i) => (
        <StyledPairedButton
          key={i}
          className={`${active === i ? 'active' : ''} ${small ? 'small' : ''}`}
          disabled={disabled}
          onClick={toggleActive(i)}
        >
          {buttonText}
        </StyledPairedButton>
      ))}
    </StyledPairedButtonWrapper>
  );
};

export const MoreButton = ({
  text,
  wd,
  fn = () => {},
  butType = 'gold',
  disabled = false,
  loading = false,
}) => {
  const handlecClick = e => {
    e.stopPropagation();
    if (loading) e.preventDefault();
    fn(e);
  };

  return (
    <StyledMoreButton
      wd={wd}
      onClick={handlecClick}
      butType={butType}
      disabled={disabled}
    >
      {text}
    </StyledMoreButton>
  );
};

PairedButtons.propTypes = {
  text: PropTypes.arrayOf(PropTypes.string.isRequired),
  fn: PropTypes.func,
  activeButton: PropTypes.bool,
  active: PropTypes.number,
};

MoreButton.propTypes = {
  text: PropTypes.string.isRequired,
  wd: PropTypes.string,
  fn: PropTypes.func,
};
